"use strict";
/** @module BryxApi.ManagementApi */
Object.defineProperty(exports, "__esModule", { value: true });
var models_1 = require("../../models");
var cerealParse_1 = require("../../cerealParse");
/**
 * Mixin class for management SCU API calls.
 */
var SCUMixin = /** @class */ (function () {
    function SCUMixin() {
    }
    /**
     * Get an agency's SCU by Id
     * @param agencyId
     * @param scuId
     * @param callback
     */
    SCUMixin.prototype.getAgencySCU = function (agencyId, scuId, callback) {
        var _this = this;
        var wrappedCallback = function (request, response) {
            callback(_this.apiResultFromParse(response, models_1.FullAgencySCU.parse, 'warn'));
        };
        this.http.get("/agencies/" + agencyId + "/scus/" + scuId, null, this.unauthenticatedCallback(wrappedCallback));
    };
    /**
     * Edit an agency's SCU
     * @param agencyId
     * @param scuId
     * @param callback
     */
    SCUMixin.prototype.editAgencySCU = function (agencyId, scuId, name, stationId, callback) {
        var _this = this;
        var body = {
            name: name,
            stationId: stationId,
        };
        var wrappedCallback = function (request, response) {
            callback(_this.apiResultFromParse(response, _this.nullParser));
        };
        this.http.put("/agencies/" + agencyId + "/scus/" + scuId, null, body, this.unauthenticatedCallback(wrappedCallback));
    };
    /**
     * Add Unit to SCU
     * @param agencyId
     * @param scuId
     * @param unitId
     * @param callback
     */
    SCUMixin.prototype.addUnitToScu = function (agencyId, scuId, unitId, callback) {
        var _this = this;
        var body = {
            unitId: unitId,
        };
        var wrappedCallback = function (request, response) {
            callback(_this.apiResultFromParse(response, _this.nullParser));
        };
        this.http.post("/agencies/" + agencyId + "/scus/" + scuId + "/units", null, body, this.unauthenticatedCallback(wrappedCallback));
    };
    /**
     * Remove Unit from SCU
     * @param agencyId
     * @param scuId
     * @param unitId
     * @param callback
     */
    SCUMixin.prototype.removeUnitToScu = function (agencyId, scuId, unitId, callback) {
        var _this = this;
        var wrappedCallback = function (request, response) {
            callback(_this.apiResultFromParse(response, _this.nullParser));
        };
        this.http.del("/agencies/" + agencyId + "/scus/" + scuId + "/units/" + unitId, null, this.unauthenticatedCallback(wrappedCallback));
    };
    /**
     * Get an agency's SCU config
     * @param agencyId
     * @param scuId
     * @param callback
     */
    SCUMixin.prototype.getAgencySCUConfig = function (agencyId, scuId, callback) {
        var _this = this;
        var wrappedCallback = function (request, response) {
            callback(_this.apiResultFromParse(response, models_1.AgencySCUConfigResponse.parse, 'warn'));
        };
        this.http.get("/agencies/" + agencyId + "/scus/" + scuId + "/config", null, this.unauthenticatedCallback(wrappedCallback));
    };
    /**
     * Edit SCU Day Settings
     * @param agencyId
     * @param scuId
     * @param dayStart
     * @param dayEnd
     * @param callback
     */
    SCUMixin.prototype.editSCUDaySettings = function (agencyId, scuId, dayStart, dayEnd, callback) {
        var _this = this;
        var body = {
            dayStart: dayStart,
            dayEnd: dayEnd,
        };
        var wrappedCallback = function (request, response) {
            callback(_this.apiResultFromParse(response, _this.nullParser));
        };
        this.http.put("/agencies/" + agencyId + "/scus/" + scuId + "/config", null, body, this.unauthenticatedCallback(wrappedCallback));
    };
    /**
     * Edit SCU General Settings
     * @param agencyId
     * @param scuId
     * @param lightTimeout
     * @param pollingInterval
     * @param dayTurnoutTime
     * @param nightTurnoutTime
     * @param awsRegion
     * @param alertNewAssignments
     * @param speakNewAssignments
     * @param lightRamp
     * @param blink
     * @param callback
     */
    SCUMixin.prototype.editSCUGeneralSettings = function (agencyId, scuId, lightTimeout, pollingInterval, dayTurnoutTime, nightTurnoutTime, awsRegion, alertNewAssignments, speakNewAssignments, lightRamp, blink, callback) {
        var _this = this;
        var body = {
            lightTimeout: lightTimeout,
            pollingInterval: pollingInterval,
            dayTurnoutTime: dayTurnoutTime,
            nightTurnoutTime: nightTurnoutTime,
            awsRegion: awsRegion != null ? models_1.SCUAWSRegion[awsRegion] : null,
            alertNewAssignments: alertNewAssignments,
            speakNewAssignments: speakNewAssignments,
            lightRamp: lightRamp,
            blink: blink != null ? models_1.HueLightStateAlert[blink] : null,
        };
        var wrappedCallback = function (request, response) {
            callback(_this.apiResultFromParse(response, _this.nullParser));
        };
        this.http.put("/agencies/" + agencyId + "/scus/" + scuId + "/config", null, body, this.unauthenticatedCallback(wrappedCallback));
    };
    /**
     * Edit SCU Audio Settings
     * @param agencyId
     * @param scuId
     * @param systemVolume
     * @param toneVolume
     * @param dayRamp
     * @param nightRamp
     * @param callback
     */
    SCUMixin.prototype.editSCUAudioSettings = function (agencyId, scuId, systemVolume, toneVolume, dayRamp, nightRamp, callback) {
        var _this = this;
        var body = {
            systemVolume: systemVolume,
            toneVolume: toneVolume,
            dayRamp: dayRamp != null ? models_1.SCURampLength[dayRamp] : null,
            nightRamp: nightRamp != null ? models_1.SCURampLength[nightRamp] : null,
        };
        var wrappedCallback = function (request, response) {
            callback(_this.apiResultFromParse(response, _this.nullParser));
        };
        this.http.put("/agencies/" + agencyId + "/scus/" + scuId + "/config", null, body, this.unauthenticatedCallback(wrappedCallback));
    };
    /**
     * Edit SCU TTS Settings
     * @param agencyId
     * @param scuId
     * @param voice
     * @param rate
     * @param repetitions
     * @param ttsVolume
     * @param lexicons
     * @param textToSpeech
     * @param callback
     */
    SCUMixin.prototype.editSCUTtsSettings = function (agencyId, scuId, voice, rate, repetitions, ttsVolume, lexicons, textToSpeech, callback) {
        var _this = this;
        var body = {
            ttsVoice: voice ? models_1.SCUTTSVoice[voice] : null,
            rate: rate,
            repetitions: repetitions,
            ttsVolume: ttsVolume,
            lexicons: lexicons,
            textToSpeech: textToSpeech,
        };
        var wrappedCallback = function (request, response) {
            callback(_this.apiResultFromParse(response, _this.nullParser));
        };
        this.http.put("/agencies/" + agencyId + "/scus/" + scuId + "/config", null, body, this.unauthenticatedCallback(wrappedCallback));
    };
    /**
     * Create SCU Zone
     * @param agencyId
     * @param scuId
     * @param name
     * @param units
     * @param bridgeMac
     * @param callback
     */
    SCUMixin.prototype.createSCUZone = function (agencyId, scuId, name, units, bridgeMac, callback) {
        var _this = this;
        var body = {
            name: name,
            units: units,
            audio: [],
            lights: [],
            bridgeMac: bridgeMac,
        };
        var wrappedCallback = function (request, response) {
            callback(_this.apiResultFromParse(response, models_1.SCUZone.parse));
        };
        this.http.post("/agencies/" + agencyId + "/scus/" + scuId + "/config/zones", null, body, this.unauthenticatedCallback(wrappedCallback));
    };
    /**
     * Edit SCU Zone
     * @param agencyId
     * @param scuId
     * @param zoneId
     * @param name
     * @param units
     * @param audio
     * @param lights
     * @param bridgeMac
     * @param callback
     */
    SCUMixin.prototype.editSCUZone = function (agencyId, scuId, zoneId, name, units, audio, lights, bridgeMac, callback) {
        var _this = this;
        var body = {
            name: name,
            units: units,
            audio: audio,
            lights: lights,
            bridgeMac: bridgeMac,
        };
        var wrappedCallback = function (request, response) {
            callback(_this.apiResultFromParse(response, models_1.SCUZone.parse));
        };
        this.http.put("/agencies/" + agencyId + "/scus/" + scuId + "/config/zones/" + zoneId, null, body, this.unauthenticatedCallback(wrappedCallback));
    };
    /**
     * Delete SCU Zone
     * @param agencyId
     * @param scuId
     * @param zoneId
     * @param callback
     */
    SCUMixin.prototype.deleteSCUZone = function (agencyId, scuId, zoneId, callback) {
        var _this = this;
        var wrappedCallback = function (request, response) {
            callback(_this.apiResultFromParse(response, _this.nullParser));
        };
        this.http.del("/agencies/" + agencyId + "/scus/" + scuId + "/config/zones/" + zoneId, null, this.unauthenticatedCallback(wrappedCallback));
    };
    /**
     * Pair board to zone.
     * @param agencyId
     * @param scuId
     * @param zoneId
     * @param code
     * @param callback
     */
    SCUMixin.prototype.pairBoardToZone = function (agencyId, scuId, zoneId, code, callback) {
        var _this = this;
        var body = {
            code: code,
        };
        var wrappedCallback = function (request, response) {
            callback(_this.apiResultFromParse(response, _this.nullParser));
        };
        this.http.put("/agencies/" + agencyId + "/scus/" + scuId + "/config/zones/" + zoneId + "/pair", null, body, this.unauthenticatedCallback(wrappedCallback));
    };
    /**
     * editGeneralScuConfig
     * @param systemVolume
     * @param toneVolume
     * @param ttsVoice
     * @param ttsVolume
     * @param rate
     * @param repetitions
     */
    SCUMixin.prototype.editGeneralScuConfig = function (agencyId, scuId, systemVolume, toneVolume, ttsVoice, ttsVolume, rate, repetitions, callback) {
        var _this = this;
        var strVoice = models_1.SCUTTSVoice[ttsVoice];
        var body = {
            systemVolume: systemVolume,
            toneVolume: toneVolume,
            ttsVoice: strVoice,
            ttsVolume: ttsVolume,
            rate: rate,
            repetitions: repetitions,
        };
        var wrappedCallback = function (request, response) {
            callback(_this.apiResultFromParse(response, _this.nullParser));
        };
        this.http.put("/agencies/" + agencyId + "/scus/" + scuId + "/config", null, body, this.unauthenticatedCallback(wrappedCallback));
    };
    /**
     * Create alert setting for SCU
     * @param agencyId
     * @param scuId
     * @param match
     * @param audio
     * @param color
     * @param lightTimeout
     * @param repetitions
     * @param ttsVolume
     * @param toneVolume
     * @param lightRamp
     * @param blink
     */
    SCUMixin.prototype.createSCUAlertSetting = function (agencyId, scuId, priority, match, audio, color, lightTimeout, repetitions, ttsVolume, toneVolume, lightRamp, blink, callback) {
        var _this = this;
        var body = {
            matchType: match.type,
            matchTypeCode: match.typeCode,
            matchUnit: match.unit,
            matchBox: match.box,
            matchPriority: match.priority,
            priority: priority,
            audio: audio,
            color: color,
            lightTimeout: lightTimeout,
            repetitions: repetitions,
            ttsVolume: ttsVolume,
            toneVolume: toneVolume,
            lightRamp: lightRamp,
            blink: blink != null ? models_1.HueLightStateAlert[blink] : null,
        };
        var wrappedCallback = function (request, response) {
            callback(_this.apiResultFromParse(response, models_1.SCUAlertSetting.parse));
        };
        this.http.post("/agencies/" + agencyId + "/scus/" + scuId + "/config/alert-settings", null, body, this.unauthenticatedCallback(wrappedCallback));
    };
    /**
     * Edit alert setting for SCU
     * @param agencyId
     * @param scuId
     * @param settingId
     * @param priority
     * @param matchType
     * @param matchTypeCode
     * @param matchUnit
     * @param audio
     * @param color
     * @param lightTimeout
     * @param repetitions
     * @param ttsVolume
     * @param toneVolume
     * @param lightRamp
     * @param blink
     */
    SCUMixin.prototype.editSCUAlertSetting = function (agencyId, scuId, settingId, priority, matchType, matchTypeCode, matchUnit, audio, color, lightTimeout, repetitions, ttsVolume, toneVolume, lightRamp, blink, callback) {
        var _this = this;
        var body = {
            matchType: matchType,
            matchTypeCode: matchTypeCode,
            matchUnit: matchUnit,
            matchBox: null,
            matchPriority: null,
            priority: priority,
            audio: audio,
            color: color,
            lightTimeout: lightTimeout,
            repetitions: repetitions,
            ttsVolume: ttsVolume,
            toneVolume: toneVolume,
            lightRamp: lightRamp,
            blink: blink,
        };
        var wrappedCallback = function (request, response) {
            callback(_this.apiResultFromParse(response, models_1.SCUAlertSetting.parse));
        };
        this.http.put("/agencies/" + agencyId + "/scus/" + scuId + "/config/alert-settings/" + settingId, null, body, this.unauthenticatedCallback(wrappedCallback));
    };
    /**
     * Delete alert setting for SCU
     * @param agencyId
     * @param scuId
     * @param settingId
     * @param callback
     */
    SCUMixin.prototype.deleteSCUAlertSetting = function (agencyId, scuId, settingId, callback) {
        var _this = this;
        var wrappedCallback = function (request, response) {
            callback(_this.apiResultFromParse(response, _this.nullParser));
        };
        this.http.del("/agencies/" + agencyId + "/scus/" + scuId + "/config/alert-settings/" + settingId, null, this.unauthenticatedCallback(wrappedCallback));
    };
    /**
     * Push config to SCU
     * @param scuId
     * @param agencyId
     */
    SCUMixin.prototype.pushScuConfig = function (agencyId, scuId, callback) {
        var _this = this;
        var wrappedCallback = function (request, response) {
            callback(_this.apiResultFromParse(response, function (o) {
                try {
                    return cerealParse_1.ParseUtils.parseSuccess(cerealParse_1.ParseUtils.getString(o, 'response'));
                }
                catch (e) {
                    return cerealParse_1.ParseUtils.parseFailure('Failed to load response');
                }
            }));
        };
        this.http.post("/agencies/" + agencyId + "/scus/" + scuId + "/push-config", null, null, this.unauthenticatedCallback(wrappedCallback));
    };
    return SCUMixin;
}());
exports.default = SCUMixin;
//# sourceMappingURL=SCUMixin.js.map